<template>
    <div class="individual">
        <div class="individual-box">
            <div class="individual-tit">
                <span class="individual-tit-line"></span>
                <span class="individual-tit-bold">修改密码</span>
            </div>

            <!--<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="密码" prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="年龄" prop="age">
                    <el-input v-model.number="ruleForm.age"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>-->

            <div class="individual-info">
                <div class="info-username">
                    <span class="individual-span">手机号码:</span>
                    <span class="individual-name">{{ phone }}</span>
                </div>
                <div class="info-nicheng">
                    <span class="individual-span">验证码:</span>
                    <div class="verificationCode">
                        <el-input class="info-nicheng-input" placeholder="请输入短信验证码" v-model="code"></el-input>
                        <div class="getCode">
                            <span class="getCodeBtn" v-show="showTime" @click="getCode()">获取验证码</span>
                            <span class="getCodeTime" v-show="!showTime">{{ sendTime }}s</span>
                        </div>
                    </div>
                </div>
                <div class="info-sex">
                    <span class="individual-span">新密码:</span>
                    <el-input type="password" style="width: 300px;" placeholder="请输入新密码" v-model="newPwd"></el-input>
                </div>
                <div class="info-brithday">
                    <span class="individual-span">确认密码:</span>
                    <el-input type="password" style="width: 300px;" placeholder="再次输入密码确认"
                              v-model="newPwdSure"></el-input>
                </div>
                <div class="info-btn">
                    <span class="individual-span"></span>
                    <span class="info-btn-submit" @click="changePwd">修改</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "modify",
        data() {
            var checkAge = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('年龄不能为空'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if (value < 18) {
                            callback(new Error('必须年满18岁'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };


            return {
                /*ruleForm: {
                    pass: '',
                    checkPass: '',
                    age: ''
                },
                rules: {
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    age: [
                        { validator: checkAge, trigger: 'blur' }
                    ]
                }*/

                showTime: true, /* 布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
                sendTime: '', /* 倒计时 计数器 */
                timer: null,
                sendSuccess: false, //短信是否发送成功
                sixten: 60, //60秒倒计时

                sex: 0,
                brithday: '',
                code: '',
                newPwd: '',
                newPwdSure: '',
                phone:'',
            }
        },
        mounted() {
          this.myBaseInfo();
        },
        methods: {
            sexChange(idx) {
                console.log(idx);
            },

            /*submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },*/

            /*发送验证码时，开始计数，一分钟发送一次*/
            getCode() {
              const TIME_COUNT = 60; //  更改倒计时时间
              var that = this;
              var index;
              /*layui.use('layer', function () {
                var layer = layui.layer;
                index = layer.load(1, {
                  shade: [0.1, '#fff'] //0.1透明度的白色背景
                });
              });*/
              that.$axios.post("/getVerfyCode", {
                phone: that.phone,
                use_type: 5,
              }).then((res) => {
                console.log(res);
                res = res.data;
                if (res.status == 200) {
                  // layer.closeAll();
                  // layer.msg(res.message);
                    this.$message(res.message);
                  if (!this.timer) {
                      this.sendTime = TIME_COUNT;
                      this.showTime = false;
                      this.timer = setInterval(() => {
                          if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
                              this.sendTime--;
                          } else {
                              this.showTime = true;
                              clearInterval(this.timer); // 清除定时器
                              this.timer = null;
                          }
                      }, 1000);
                  }
                  that.sendSuccess = true;
                  //倒计时
                  that.time_down();
                } else {
                  // layer.closeAll();
                  // layer.msg(res.message, {icon: 2});
                    this.$message(res.message);
                }//请求成功返回的数据
              }).catch((error) => {
                // layer.closeAll();
                // layer.msg('系统错误', {
                //   icon: 2
                // });
                  this.$message('系统错误');
              });
            },
            //倒计时注册
            time_down() {
              var that = this;
              //记录点击时间
              var t1 = window.setInterval(function () {
                var num = that.sixten;
                num = num - 1;
                if (num < 1) {
                  that.sendSuccess = false;
                  window.clearInterval(t1);
                  that.sixten = 60;
                } else {
                  that.sixten = num;
                }
              }, 1000);
            },
            myBaseInfo(){
              this.$axios.get("/myBaseInfo").then((res)=>{
                // console.log(res);
                res = res.data;
                if (res.status == 200) {
                  this.phone = res.data.phone;
                } else {
                  // layer.msg(res.msg, {icon: 2});
                    this.$message(res.msg);
                }//请求成功返回的数据
              })
            },
            /*修改密码*/
            changePwd(){
              var verifyCode = this.code;
              var password = this.newPwd;
              var repwd = this.newPwdSure;
              this.$axios.post("/changePwdPc", {
                verifyCode,
                password,
                repwd,
              }).then((res) => {
                // console.log(res);
                res = res.data;
                if (res.status == 200) {
                  // layer.msg('修改成功', {icon: 1});
                    this.$message('修改成功');
                  this.code = '';
                  this.newPwd = '';
                  this.newPwdSure = '';
                } else {
                  // layer.msg(res.message, {icon: 2});
                    this.$message(res.message);
                }//请求成功返回的数据
              }).catch((error) => {
                // layer.closeAll();
                // layer.msg('系统错误', {
                //   icon: 2
                // });
                  this.$message('系统错误');
              });
            }
        }
    }
</script>

<style scoped>
    .individual {
        width: 998px;
        border: 1px solid #EEEEEE;
    }

    .individual-box {
        width: 958px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .individual-tit {
        height: 49px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-tit-line {
        width: 2px;
        height: 14px;
        background: #FF5227;
    }

    .individual-tit-bold {
        margin-left: 10px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .individual-info {
        width: 700px;
        margin-top: 30px;
        margin-bottom: 65px;
    }

    .individual-span {
        width: 70px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: right;
        margin-right: 20px;
    }

    .info-username {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .individual-name {
        margin-left: 6px;
        margin-right: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .info-nicheng {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .verificationCode {
        width: 300px;
        position: relative;
    }

    .info-nicheng-input {
        width: 300px;
    }

    .info-nicheng >>> .el-input__inner {
        padding: 0 100px 0 15px;
    }

    .getCode {
        width: 100px;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 20;
    }

    .getCodeBtn {
        width: 90px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2577E3;
    }

    .getCodeTime {
        width: 60px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF5227;
    }

    .info-sex {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-brithday {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .date-wt {
        width: 300px;
    }

    .info-btn {
        margin-top: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .info-btn-submit {
        width: 200px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #FF5227;
        border-radius: 2px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/modify.vue